<template>
  <el-select v-model="selectEmployees" placeholder="请选择人员" @change="onSelectEmployeeChanged" multiple filterable>
    <el-option
      v-for="item in allEmployees"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "selectEmployee",
  props:['employees','index'],
  data(){
    return{
      selectEmployees:[],
      allEmployees:[],
    }
  },

  watch:{
    employees:{
      immediate:true,
      deep:true,
      handler(val){
        this.selectEmployees=val;
      }
    }
  },

  mounted() {
    this.$commonConfig.getEmployeeList().then(res=>{
      this.allEmployees=res;
    })
  },

  methods:{
    onSelectEmployeeChanged(e){
      this.$emit('onSelectEmployeeChanged',e,this.index)
    }
  }
}
</script>

<style scoped>

</style>
